import { useState, Fragment, useContext } from "react";
import { Grid } from "@mui/material";

import "./ksopPersonalInformation.css";
import { AuthContext } from "../../../../../../../contexts";
import { formatSSN } from "../../../../../../../utils/commonFunctions/SSN";
/* eslint-disable */

const PersonalInformationBlock = ({ field, value }) => {
	return (
		<div className="inside-item-border">
			<Grid container spacing={0}>
				<Grid item xs={6}>
					<div style={{ fontSize: "14px" }}>{field}</div>
				</Grid>
				<Grid item xs={6}>
					{" "}
				</Grid>
				<Grid item xs={6}>
					{" "}
				</Grid>
				<Grid item xs={6}>
					<div>{value}</div>
				</Grid>
			</Grid>
		</div>
	);
};

const KsopPersonalInformation = (props) => {
	const { member } = useContext(AuthContext);

	return (
		<div className="ksop-block">
			<div className="side-box">Must Complete</div>
			<div className="content-box-gray">
				<div className="title">Personal Information (Please Print or Type)</div>

				<div className="content">
					<Grid container spacing={0}>
						<Grid item xs={6}>
							<PersonalInformationBlock field="Company Name" value="BROOKSHIRE BROTHERS, INC." />
						</Grid>
						<Grid item xs={6}>
							<PersonalInformationBlock field="Contact/Plan I.D. Number" value="KSOP / 706751" />
						</Grid>
						<Grid item xs={6}>
							<PersonalInformationBlock
								field="Participant"
								value={member.first_name + " " + member.last_name}
							/>
						</Grid>
						<Grid item xs={6}>
							<PersonalInformationBlock field="Social Security Number" value={formatSSN(member.SSN)} />
						</Grid>
						<Grid item xs={6}>
							<div
								className="inside-item"
								style={{ paddingTop: "1px", paddingTop: "1px", paddingLeft: "5px", fontSize: "14px" }}
							>
								<p>Phone Number or E-mail (if clarification is needed)</p>
								<p style={{ fontSize: "14px", display: "flex" }}>
									Phone Number:{" "}
									<div style={{ color: "#c9c9c9", paddingLeft: "5px" }}>{member.phone_number}</div>
								</p>
							</div>
						</Grid>
						<Grid item xs={6}>
							<div className="inside-item" style={{ paddingTop: "25px", fontSize: "14px" }}>
								Email : {member.email}
							</div>
						</Grid>
					</Grid>
				</div>
			</div>
		</div>
	);
};
export default KsopPersonalInformation;
